import script from "./floating-action-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./floating-action-button.vue?vue&type=script&lang=ts&setup=true"

import "./floating-action-button.vue?vue&type=style&index=0&id=e4b7b4ae&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4b7b4ae"]])

export default __exports__